/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockMenuIngredientCtrl
 */
angular.module('mercury.modules.stock.menu')
.controller('StockMenuIngredientCtrl', ["dialog", "$filter", "$scope", "$stateParams", "StockMenus", "title", function(dialog, $filter, $scope, $stateParams, StockMenus, title) {
  title.set('Menu Ingredients');

  $scope.menuId = $stateParams.id;
  $scope.items = StockMenus.getIngredients($stateParams.id);
  $scope.items.$promise.then(function() {
    $scope.hasDeleted = $filter('filter')($scope.items, {datestampRemoved: ''}).length !== 0;
  }, function() {
    $state.go('Stock.Menu');
  });
}]);
